<template>
    <div class="barcode-container" v-if="wineInfo">
        <h2>Wine details:</h2>
        <div class="barcode-row">
            <div class="bold">Producer:</div>
            {{wineInfo.producer}}
        </div>
        <div class="barcode-row">
            <div class="bold">Vintage:</div>
            {{wineInfo.vintage}}
        </div>
        <div class="barcode-row">
            <div class="bold">{{ $t('address15') }}:</div>
            {{wineInfo.country}}
        </div>
        <div class="barcode-row">
            <div class="bold">{{ $t('region') }}:</div>
            {{wineInfo.region}}
        </div>
        <div class="barcode-row">
            <div class="bold">Appellation:</div>
            {{wineInfo.appellation}}
        </div>
        <div class="barcode-row">
            <div class="bold">Classification:</div>
            {{wineInfo.classification}}
        </div>
        <div class="barcode-row">
            <div class="bold">Case size:</div>
            {{wineInfo.caseSize}}l
        </div>

        <h2>Case details:</h2>
        <div class="barcode-row">
            <div class="bold">Case ID:</div>
            {{wineInfo.caseId}}
        </div>
        <div class="barcode-row">
            <div class="bold">Warehouse location:</div>
            {{wineInfo.warehouse}}
        </div>
        <div class="barcode-row">
            <div class="bold">Last trade date:</div>
            {{formatDate(wineInfo.lastTradeDate)}}
        </div>
        <div class="barcode-row">
            <div class="bold">Transaction ID:</div>
            {{wineInfo.transactionId}}
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {GWines} from '../store/getters';
    import {AWines} from "../store/actions";
    import moment from 'moment'

    export default {
        name: "Barcode",
        head: {
            title: 'Barcode information | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'barcode-page'
            }
        },
        computed: {
            ...mapGetters({
                wineInfo: GWines.GET_BARCODE_INFO
            })
        },
        created() {
            this.getInfo(this.$route.query.id)
        },
        methods: {
            ...mapActions({
                getInfo: AWines.GET_BARCODE_INFO
            }),
            formatDate(date) {
                return moment(date).locale(this.$i18n.locale).format('DD.MM.YYYY H:mm')
            }
        }
    }
</script>

<style scoped>
    .barcode-container {
        padding: 50px 15px;
        font-size: 16px;
    }

    h2 {
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .bold {
        display: inline-block;
        margin-right: 5px;
        font-weight: bold;
    }

    .footer-copyright {
        position: fixed;
        bottom: 0;
    }
</style>
<style>
    .barcode-page .logo {
        padding-right: 0;
    }

    .v-navigation-drawer--is-mobile {
        z-index: 106;
    }
</style>
